import React, { useState } from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import { getStageName } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import StageSelector from './StageSelector';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import StageDescriptionTooltip from './StageDescriptionTooltip';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles((theme: any) => ({
  stageNameContainer: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  stageName: {
    position: 'relative',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    color: theme.palette.brand.greenDark,
  },
  mobileStageName: { fontWeight: 'bold' },
  arrow: {
    position: 'absolute',
    color: theme.palette.brand.greyDark,
    width: 14,
  },
}));

function getNameStyle(edit: boolean) {
  return {
    width: edit ? `calc(100% + 8px)` : '100%',
    marginLeft: edit ? -4 : 0,
    cursor: edit ? 'pointer' : 'default',
  };
}

export default function StageName({
  stage,
  handleStageUpdate,
  edit,
  setAutoSave = (arg) => {},
}) {
  const mobile = useMobile('sm');
  const name = getStageName(stage.name);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles({ stage });

  const openStageSelector = (event) => {
    setAutoSave(false);
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  function handleNameChange(stageName: string) {
    handleStageUpdate(stage.id, 'name', stageName);
  }

  return (
    <div className={mobile ? null : classes.stageNameContainer}>
      <StageDescriptionTooltip stage={stage}>
        <Typography
          variant={mobile ? 'body1' : 'subtitle1'}
          className={
            classes.stageName + ' ' + mobile ? classes.mobileStageName : null
          }
          style={getNameStyle(edit)}
          onClick={openStageSelector}
        >
          {name}
          {edit && (
            <>
              {open && <ArrowDropUpIcon className={classes.arrow} />}
              {!open && <ArrowDropDownIcon className={classes.arrow} />}
            </>
          )}
        </Typography>
      </StageDescriptionTooltip>
      {edit && (
        <StageSelector
          anchorEl={anchorEl}
          open={open}
          setOpen={setOpen}
          onChange={handleNameChange}
          setAutoSave={setAutoSave}
        />
      )}
    </div>
  );
}
